$(document).ready(function () {
  $('.js-change-currency').bind('click', function (event) {
    event.preventDefault();
    let currencyLabel = $(this).data('currency');
    document.cookie = 'currency=' + currencyLabel + '; expires=10; path=/';
    location.reload();
  });
});
